import { AbstractApi } from '../AbstractApi';

/**
 * API class to call nosession API commands
 */
export class NoSessionApi extends AbstractApi {
    protected static page = 'ajax_nosession';
}
